export default __webpack_public_path__ + "static/media/nftTrade.d6b23f1d.png";